<template>
    <el-breadcrumb separator="/" class="tags-breadcrumb-list">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if='item.name'>
          <span v-if='item.redirect === undefined ||index==levelList.length-1' class="no-redirect">{{item.name}}</span>
          <router-link v-else :to="item.redirect||item.path">{{item.name}}</router-link>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'breadcrumb',
  data() {
    return {
      levelList: []
    }
  },
  created() {
    this.getBreadcrumb()
  },
  mounted() {},
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  computed: {
    ...mapGetters(['tagCurrent'])
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      if (first && first.name !== '首页') {
        matched = [{ path: '/wel/index', name: '首页' }].concat(matched)
      }
      this.levelList = matched
    }
  }
}
</script>
<style lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>


